<template>
    <CommonList
            selection-type="checkbox"
            row-key="id"
            :has-more-search="false"
            :auto-load="true"
            ref="listRef"
            cellOverflow="ellipsis"
            @selection-change="handleSelectionChange"
            @current-row-change="handleCurrentRowChange"
            @load-start="handleLoadList"
            @search-click="handleLoadList"
            @pagination-change="handleLoadList"
            @reset-click="handleReset"
    >
        <template #btn-group>
            <el-button type="danger" class="list-btn" @click="handleBatchAuditFail" :disabled="selectedRows.length === 0">
                批量信息错误
            </el-button>
            <el-button type="primary" class="list-btn" @click="handleBatchConfirmVehicle" :disabled="selectedRows.length === 0">
                批量年检生成
            </el-button>
            <el-button type="success" class="list-btn" @click="handleBatchSaveCheckInfo" :disabled="selectedRows.length === 0">
                批量年检确认
            </el-button>
            <el-button type="warning" class="list-btn" @click="handleCleanLicenseImages">
                清理行驶证图片
            </el-button>
            <span class="selected-count" v-if="selectedRows.length > 0">已选 {{ selectedRows.length }} 条</span>
        </template>

        <template #search-item-fixed>
            <div class="common-search-item">
                <label class="common-search-label80">车牌号：</label>
                <el-input v-model="searchForm.plateNumber" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">身份证号：</label>
                <el-input v-model="searchForm.idCard" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">审核状态：</label>
                <el-select v-model="searchForm.status" class="common-input100" placeholder="请选择">
                    <el-option label="审核中" value="1"></el-option>
                    <el-option label="已绑定" value="2"></el-option>
                    <el-option label="审核失败" value="3"></el-option>
                    <el-option label="已删除" value="0"></el-option>
                </el-select>
            </div>
        </template>
        <template #table-column>
            <el-table-column prop="userName" label="车主姓名" align="center" width="120"></el-table-column>
            <el-table-column prop="plateNumber" label="车牌号" align="center" width="120"></el-table-column>
            <el-table-column prop="vin" label="车辆识别代号" align="center" width="220">
                <template #default="scope">
                    {{ scope.row.vin || '-' }}
                </template>
            </el-table-column>
            <el-table-column prop="vehicleType" label="车辆类型" align="center" width="140">
                <template #default="scope">
                    {{ scope.row.vehicleType || '-' }}
                </template>
            </el-table-column>
            <el-table-column prop="useNature" label="使用性质" align="center" width="120">
                <template #default="scope">
                    {{ scope.row.useNature || '-' }}
                </template>
            </el-table-column>
            <el-table-column prop="registerDate" label="注册日期" align="center" width="120">
                <template #default="scope">
                    {{ scope.row.registerDate || '-' }}
                </template>
            </el-table-column>
            <el-table-column prop="checkCycle" label="检验周期/月" align="center" width="120">
                <template #default="scope">
                    <el-input-number v-if="scope.row.status === '1'" v-model="scope.row.checkCycle" :controls="false" :min="1" :max="60" size="small" style="width: 80px;"></el-input-number>
                    <span v-else>{{ scope.row.checkCycle || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="checkExpireDate" label="检验到期日" align="center" width="160">
                <template #default="scope">
                    <el-date-picker v-if="scope.row.status === '1'" v-model="scope.row.checkExpireDate" type="month" format="YYYY-MM-DD" value-format="YYYY-MM-DD" size="small" style="width: 140px;" placeholder="选择月份" @change="(val) => handleRowMonthChange(scope.row)"></el-date-picker>
                    <span v-else>{{ scope.row.checkExpireDate || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="checkType" label="检车类型" align="center" width="110">
                <template #default="scope">
                    <el-select v-if="scope.row.status === '1'" v-model="scope.row.checkType" size="small" style="width: 90px;" placeholder="选择">
                        <el-option label="年检" value="年检"></el-option>
                        <el-option label="免检" value="免检"></el-option>
                    </el-select>
                    <span v-else>{{ scope.row.checkType || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="statusText" label="车辆状态" align="center" width="100">
                <template #default="scope">
                    <el-tag :type="getStatusTagType(scope.row.status)">
                        {{ scope.row.statusText }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="auto" :resizable="false">
                <template #default="scope">
                    <template v-if="scope.row.status === '1'">
                        <div style="margin-bottom: 4px;">
                            <el-button type="danger" size="small" @click="openAuditFailDialog(scope.row)">信息错误</el-button>
                            <el-button type="primary" size="small" @click="handleConfirmVehicle(scope.row.id)">年检生成</el-button>
                        </div>
                        <div>
                            <el-button type="success" size="small" @click="handleSaveCheckInfo(scope.row)" :disabled="!scope.row.checkExpireDate">年检确认</el-button>
                            <el-button type="info" size="small" @click="openDetail(scope.row.id)">详情</el-button>
                        </div>
                    </template>
                    <template v-else>
                        <el-button type="info" size="small" @click="openDetail(scope.row.id)">查看</el-button>
                    </template>
                </template>
            </el-table-column>
        </template>

        <template #extra>
            <el-dialog
                    v-model="dialogVisible"
                    title="车辆审核详情"
                    width="900px"
                    destroy-on-close
            >
                <el-form label-width="100px" class="list-modal-form">
                    <el-divider content-position="left" style="margin: 0 0 15px 0;">车辆信息</el-divider>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="车主姓名">
                                <el-input v-model="formData.userName" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车牌号">
                                <el-input v-model="formData.plateNumber" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车辆识别代号">
                                <el-input v-model="formData.vin" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车辆类型">
                                <el-input v-model="formData.vehicleType" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="使用性质">
                                <el-input v-model="formData.useNature" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="注册日期">
                                <el-input v-model="formData.registerDate" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车辆状态">
                                <el-tag :type="getStatusTagType(formData.status)">
                                    {{ formData.statusText }}
                                </el-tag>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <template v-if="formData.status !== '2'">
                    <el-divider content-position="left" style="margin: 20px 0 15px 0;">行驶证图片</el-divider>
                    <div v-if="formData.licenseImageUrl" style="text-align: center; margin-bottom: 20px;">
                        <el-image
                            :src="formData.licenseImageUrl"
                            :preview-src-list="[formData.licenseImageUrl]"
                            fit="contain"
                            style="max-width: 600px; max-height: 400px; border: 1px solid #ebeef5; border-radius: 4px;"
                            :preview-teleported="true"
                        >
                            <template #error>
                                <div style="width: 600px; height: 200px; display: flex; align-items: center; justify-content: center; background: #f5f7fa; color: #909399;">
                                    图片加载失败
                                </div>
                            </template>
                        </el-image>
                    </div>
                    <div v-else style="text-align: center; margin-bottom: 20px; color: #909399;">
                        暂无行驶证图片
                    </div>
                    </template>

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="检验周期/月">
                                <el-input-number v-model="formData.checkCycle" :controls="false" :min="1" :max="60" :precision="0" :disabled="formData.status !== '1'" placeholder="请输入月份" style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="备注">
                                <el-input
                                        v-model="formData.remark"
                                        type="textarea"
                                        :rows="3"
                                        :disabled="formData.status !== '1'"
                                        placeholder="审核失败时填写失败原因"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="formData.status === '1'">
                            <div style="text-align: center; margin-top: 10px;">
                                <el-button type="danger" @click="handleAuditFailDetail">信息错误</el-button>
                                <el-button type="primary" @click="handleConfirmVehicleDetail" style="margin-left: 15px;">年检生成</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>

                <template v-if="formData.status !== '3'">
                    <div style="margin-top: 20px; display: flex; gap: 20px;">
                        <div style="flex: 1; background: #fafafa; border-radius: 8px; padding: 20px;">
                            <h4 style="margin: 0 0 15px 0; font-size: 15px; font-weight: 600; color: #333;">车辆年检信息</h4>
                            <el-form label-width="100px">
                                <el-form-item label="检验到期日">
                                    <el-date-picker v-model="checkForm.checkExpireDate" type="month" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :disabled="formData.status !== '1'" style="width: 100%;"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="检车类型">
                                    <el-select v-model="checkForm.checkType" placeholder="请选择" :disabled="formData.status !== '1'" style="width: 100%;">
                                        <el-option label="年检" value="年检"></el-option>
                                        <el-option label="免检" value="免检"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </template>

                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <template v-if="formData.status === '1'">
                            <el-button type="success" @click="handleSaveCheckInfoDetail" :disabled="!checkForm.checkExpireDate">年检确认</el-button>
                        </template>
                    </div>
                </template>
            </el-dialog>
        </template>
    </CommonList>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { request } from '@/util/globalContext'
import { baseURL } from '@/util/request'
import { listCommon } from '@/util/vueutil/commonList.js'

const listRef = ref(null)
const dialogVisible = ref(false)
const vehicleId = ref('')
const selectedRow = ref(null)
const selectedRows = ref([])
const isLoadingDetail = ref(false)

const formData = reactive({
    userName: '',
    plateNumber: '',
    vin: '',
    vehicleType: '',
    useNature: '',
    registerDate: '',
    checkCycle: '',
    status: '',
    statusText: '',
    remark: '',
    licenseImageUrl: ''
})

const checkForm = reactive({
    checkExpireDate: '',
    checkType: '',
    checkYear: ''
})

// 入参 YYYY-MM-DD（type=month 默认给出当月第一天），返回当月最后一天
const getLastDayOfMonth = (dateStr) => {
    if (!dateStr) return ''
    const [y, m] = dateStr.split('-').map(Number)
    const lastDay = new Date(y, m, 0).getDate()
    return `${String(y).padStart(4, '0')}-${String(m).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`
}

// 表格行：选完月份后（默认给的是当月第一天），自动替换成当月最后一天
const handleRowMonthChange = (row) => {
    if (!row.checkExpireDate) return
    const lastDay = getLastDayOfMonth(row.checkExpireDate)
    if (row.checkExpireDate !== lastDay) {
        row.checkExpireDate = lastDay
    }
}

// 详情页checkForm：选完月份后自动替换成当月最后一天
watch(
    () => checkForm.checkExpireDate,
    (newVal) => {
        if (!newVal) return
        const lastDay = getLastDayOfMonth(newVal)
        if (newVal !== lastDay) {
            checkForm.checkExpireDate = lastDay
        }
    }
)

const searchForm = reactive({
    plateNumber: '',
    idCard: '',
    status: ''
})

const { handleReset } = listCommon(searchForm)

const getStatusTagType = (status) => {
    const map = {
        '0': 'info',
        '1': 'warning',
        '2': 'success',
        '3': 'danger'
    }
    return map[status] || 'info'
}

const handleSelectionChange = (val) => {
    selectedRows.value = val || []
    selectedRow.value = val?.length ? val[0] : null
}

const handleCurrentRowChange = (val) => {
    selectedRow.value = val
}

const openDetail = async (id) => {
    vehicleId.value = id
    dialogVisible.value = true
    await loadDetail()
}

const loadDetail = async () => {
    isLoadingDetail.value = true
    try {
        const res = await request.get('/wxapi/getVehicleAuditDetail', { params: { vehicleId: vehicleId.value } })
        if (res.code === 200) {
            const data = res.data || {}
            Object.assign(formData, {
                userName: data.userName || '',
                plateNumber: data.plateNumber || '',
                vin: data.vin || '',
                vehicleType: data.vehicleType || '',
                useNature: data.useNature || '',
                registerDate: data.registerDate || '',
                checkCycle: data.checkCycle || '',
                status: data.status || '',
                statusText: data.statusText || '',
                remark: data.remark || '',
                licenseImageUrl: data.licenseImage ? (baseURL + '/uploads/license/' + data.licenseImage) : ''
            })
            const checkInfo = data.checkInfo || {}
            Object.assign(checkForm, {
                checkExpireDate: checkInfo.checkExpireDate || '',
                checkType: checkInfo.checkType || '',
                checkYear: checkInfo.checkYear || ''
            })
        }
    } catch (error) {
        ElMessage.error('加载详情失败')
    } finally {
        isLoadingDetail.value = false
    }
}

/**
 * 公共方法：年检生成（支持单条/批量）
 */
const confirmVehicle = async (vehicleIds, isDetail = false) => {
    try {
        const res = await request.post('/wxapi/batchCalculateCheckInfo', {
            vehicleIds: Array.isArray(vehicleIds) ? vehicleIds : [vehicleIds]
        })
        if (res.code === 200) {
            const checkInfos = res.data.deletedVehicles ? res.data.checkInfos : res.data
            if (checkInfos.length > 0) {
                if (isDetail) {
                    // 详情页：更新表单数据
                    const checkInfo = checkInfos[0]
                    formData.checkCycle = checkInfo.checkCycle
                    checkForm.checkExpireDate = checkInfo.checkExpireDate
                    checkForm.checkType = checkInfo.checkType
                    checkForm.checkYear = checkInfo.checkYear
                } else {
                    // 列表页：更新表格数据
                    const tableData = listRef.value?.getTableData() || []
                    checkInfos.forEach(info => {
                        const row = tableData.find(r => String(r.id) === String(info.vehicleId))
                        if (row) {
                            row.checkCycle = info.checkCycle
                            row.checkExpireDate = info.checkExpireDate
                            row.checkType = info.checkType
                            row.checkYear = info.checkYear
                        }
                    })
                    listRef.value?.updateListData([...tableData])
                }

                if (res.data && res.data.deletedVehicles && res.data.deletedVehicles.length > 0) {
                    ElMessage.warning(`以下车辆已被车主删除，跳过处理：${res.data.deletedVehicles.join('、')}`)
                } else {
                    const checkInfo = checkInfos[0]
                    ElMessage.success(`已计算年检信息：检验到期日 ${checkInfo.checkExpireDate}`)
                }
            }
        } else {
            ElMessage.error(res.msg || '操作失败')
        }
    } catch (error) {
        ElMessage.error('操作失败')
    }
}

/**
 * 公共方法：年检确认（支持单条/批量）
 */
const saveCheckInfo = async (rows, isDetail = false) => {
    const checkInfos = Array.isArray(rows) ? rows : [rows]
    
    const invalidRows = checkInfos.filter(row => !row.checkExpireDate)
    if (invalidRows.length > 0) {
        const plateNumbers = invalidRows.map(row => row.plateNumber).join('、')
        ElMessage.warning(`以下车辆年检信息不全，请先确认车辆信息：${plateNumbers}`)
        return
    }
    
    const requestData = checkInfos.map(row => ({
        vehicleId: row.id,
        vin: row.vin,
        plateNumber: row.plateNumber,
        checkCycle: row.checkCycle,
        checkExpireDate: row.checkExpireDate,
        checkType: row.checkType,
        checkYear: row.checkYear
    }))
    
    try {
        const res = await request.post('/wxapi/batchSaveCheckInfo', {
            checkInfos: requestData
        })
        if (res.code === 200) {
            if (res.msg && res.msg.includes('已被车主删除')) {
                ElMessage.warning(res.msg)
            } else {
                ElMessage.success('年检信息保存成功')
            }
            if (isDetail) {
                dialogVisible.value = false
            }
            handleRefreshList()
        } else {
            ElMessage.error(res.msg || '操作失败')
        }
    } catch (error) {
        ElMessage.error('操作失败')
    }
}

/**
 * 公共方法：信息错误（支持单条/批量）
 */
const auditFail = async (vehicleIds, remark, isDetail = false) => {
    try {
        const res = await request.post('/wxapi/batchAuditFail', {
            vehicleIds: Array.isArray(vehicleIds) ? vehicleIds : [vehicleIds],
            remark: remark || '车辆信息错误'
        })
        if (res.code === 200) {
            if (res.msg && res.msg.includes('已被车主删除')) {
                ElMessage.warning(res.msg)
            } else {
                ElMessage.success('审核失败已记录')
            }
            if (isDetail) {
                dialogVisible.value = false
            }
            handleRefreshList()
        } else {
            ElMessage.error(res.msg || '操作失败')
        }
    } catch (error) {
        ElMessage.error('操作失败')
    }
}

/**
 * 列表单行：信息错误
 */
const openAuditFailDialog = async (vehicle) => {
    try {
        const { value: remark } = await ElMessageBox.prompt(
            `<div>车牌号：${vehicle.plateNumber}</div>`,
            '审核失败',
            {
                confirmButtonText: '确认失败',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputValue: vehicle.remark || '车辆信息错误',
                inputPlaceholder: '请输入审核失败原因',
                inputRows: 4,
                dangerouslyUseHTMLString: true,
                center: true
            }
        )
        
        if (!remark.trim()) {
            ElMessage.warning('请填写审核失败原因')
            return
        }
        
        await auditFail(vehicle.id, remark)
    } catch (error) {
        if (error !== 'cancel') {
            ElMessage.error('操作失败')
        }
    }
}

/**
 * 列表单行：年检生成
 */
const handleConfirmVehicle = async (id) => {
    await confirmVehicle(id)
}

/**
 * 列表单行：年检确认
 */
const handleSaveCheckInfo = async (row) => {
    await saveCheckInfo(row)
}

const handleAuditFailDetail = async () => {
    if (!formData.remark.trim()) {
        ElMessage.warning('请填写失败原因')
        return
    }

    await auditFail(vehicleId.value, formData.remark, true)
}

const handleConfirmVehicleDetail = async () => {
    await confirmVehicle(vehicleId.value, true)
}

const handleSaveCheckInfoDetail = async () => {
    if (!checkForm.checkExpireDate) {
        ElMessage.warning('请填写检验到期日')
        return
    }
    
    await saveCheckInfo({
        id: vehicleId.value,
        vin: formData.vin,
        plateNumber: formData.plateNumber,
        checkCycle: formData.checkCycle ? parseInt(formData.checkCycle) : null,
        checkExpireDate: checkForm.checkExpireDate,
        checkType: checkForm.checkType,
        checkYear: checkForm.checkYear
    }, true)
}

const handleBatchAuditFail = async () => {
    if (selectedRows.value.length === 0) {
        ElMessage.warning('请选择要操作的车辆')
        return
    }
    
    try {
        const { value: remark } = await ElMessageBox.prompt(
            `确定将选中的 ${selectedRows.value.length} 辆车标记为审核失败？`,
            '批量审核失败',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputValue: '车辆信息错误',
                inputPlaceholder: '请输入审核失败原因',
                inputRows: 3,
                center: true
            }
        )
        
        const vehicleIds = selectedRows.value.map(row => row.id)
        await auditFail(vehicleIds, remark)
    } catch (error) {
        if (error !== 'cancel') {
            ElMessage.error('操作失败')
        }
    }
}

const handleCleanLicenseImages = async () => {
    try {
        await ElMessageBox.confirm(
            '确定清理未被车辆关联的行驶证图片？',
            '清理行驶证图片',
            {
                confirmButtonText: '确认清理',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }
        )

        const res = await request.post('/wxapi/cleanLicenseImages')
        if (res.code === 200) {
            ElMessage.success('清理完成')
        } else {
            ElMessage.error(res.msg || '清理失败')
        }
    } catch (error) {
        if (error !== 'cancel') {
            ElMessage.error('操作失败')
        }
    }
}

const handleBatchConfirmVehicle = async () => {
    if (selectedRows.value.length === 0) {
        ElMessage.warning('请选择要操作的车辆')
        return
    }

    const vehicleIds = selectedRows.value.map(row => row.id)
    await confirmVehicle(vehicleIds)
    
    nextTick(() => {
        const selectedIds = selectedRows.value.map(r => String(r.id))
        const newTableData = listRef.value?.getTableData() || []
        const rowsToSelect = newTableData.filter(r => selectedIds.includes(String(r.id)))
        listRef.value?.restoreSelection?.(rowsToSelect)
    })
}

const handleBatchSaveCheckInfo = async () => {
    if (selectedRows.value.length === 0) {
        ElMessage.warning('请选择要操作的车辆')
        return
    }
    
    await saveCheckInfo(selectedRows.value)
}

const handleRefreshList = () => {
    if (listRef.value?.isInited) {
        const pagination = listRef.value.getPagination()
        handleLoadList(pagination)
    }
}

const handleLoadList = async (paginationParams) => {
    if (!listRef.value) return
    if (!listRef.value.isInited) {
        await nextTick()
        if (!listRef.value.isInited) {
            ElMessage.warning('列表组件初始化中，请稍后重试')
            return
        }
    }

    listRef.value.setLoading(true)
    try {
        const params = {
            ...paginationParams,
            plateNumber: searchForm.plateNumber,
            idCard: searchForm.idCard,
            status: searchForm.status
        }
        const res = await request.get('/wxapi/getVehicleAuditList', { params })
        if (res.code === 200) {
            listRef.value.updateListData(res.data.records || [])
            listRef.value.updatePagination({
                pageNum: paginationParams.pageNum,
                pageSize: paginationParams.pageSize,
                total: res.data.total || 0
            })
        } else {
            ElMessage.error('列表加载失败：' + (res.msg || '接口异常'))
            listRef.value.updateListData([])
            listRef.value.updatePagination({ ...paginationParams, total: 0 })
        }
    } catch (error) {
        ElMessage.error('列表加载失败：网络异常')
        listRef.value.updateListData([])
        listRef.value.updatePagination({ ...paginationParams, total: 0 })
    } finally {
        listRef.value.setLoading(false)
    }
}

onMounted(async () => {
    await nextTick()
    setTimeout(() => {
        if (listRef.value?.isInited) {
            const pagination = listRef.value.getPagination()
            handleLoadList(pagination)
        }
    }, 50)
})
</script>

<style>
    @import '../../../assets/css/util/base-list.css';

    .selected-count {
        margin-left: 12px;
        font-size: 14px;
        color: #409eff;
        font-weight: 600;
    }
</style>